import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import Email from './Email'
import Mail from './Mail'

function Tabs({
  switchTabs,
  isSendByEmail
}) {
  return (
    <div className="tabs">
      <ul>
        <li>
          <a
            className={isSendByEmail ? 'active' : ''}
            onClick={switchTabs}
          >
            <FormattedMessage id="Electronic invoice by Email" />
          </a>
        </li>
        <li>
          <a className={!isSendByEmail ? 'active' : ''} onClick={switchTabs}>
            <FormattedMessage id="Paper invoice by mail" />
          </a>
        </li>
      </ul>
    </div>
  )
}


class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSendByEmail: true
    }
  }

  hasError() {
    if (this.state.isSendByEmail) {
      return this.refs.email.hasError()
    }
    {
      return this.refs.mail.hasError()
    }
  }

  switchTabs() {
    this.props.resetExtras()
    this.setState({ isSendByEmail: !this.state.isSendByEmail })
  }

  render() {
    const {
      billAddress,
      phone,
      addressee,
      postcode,
      onChangeBillAddress,
      onChangePhone,
      onChangeAddressee,
      onChangePostCode
    } = this.props

    return (
      <div>
        <FormattedMessage id="Contact Information">
          {text => <p className="h2">{text}</p>}
        </FormattedMessage>
        <Tabs
          switchTabs={::this.switchTabs}
          isSendByEmail={this.state.isSendByEmail}
        />
        {this.state.isSendByEmail ? (
          <Email
            ref="email"
            intl={this.props.intl}
            billAddress={billAddress}
            phone={phone}
            onChangeBillAddress={onChangeBillAddress}
            onChangePhone={onChangePhone}
          />
        ) : (
          <Mail
            ref="mail"
            intl={this.props.intl}
            addressee={addressee}
            billAddress={billAddress}
            phone={phone}
            postcode={postcode}
            onChangeAddressee={onChangeAddressee}
            onChangeBillAddress={onChangeBillAddress}
            onChangePhone={onChangePhone}
            onChangePostCode={onChangePostCode}
          />
        )}
      </div>
    )
  }
}

export default Contact
